import styled from 'styled-components';

export const ContentButtonAddNotes = styled('div')`
  display: flex;
  justify-content: flex-end;
  height: 100%;
  flex-direction: column;
`;
